import { appPath } from "./workspace-route"
import { useLocation } from "@solidjs/router"
import { createMemo } from "solid-js"

export const scopedCollections = new Set([
  "files", "reports", "projects", "chats", "workflows", "approvals", "dashboards", "audit-log", "agents", "report-templates",
])

export type CollectionScope = { companyID?: string; projectID?: string; periodID?: string }

export function collectionRoute(pathname: string, search = "") {
  const parts = appPath(pathname).split("/").filter(Boolean)
  const query = new URLSearchParams(search)
  if (parts[0] === "companies" && parts[1] && scopedCollections.has(parts[2] ?? "") && parts.length === 3)
    return { page: parts[2]!, scope: { companyID: parts[1] } as CollectionScope }
  if (parts[0] === "projects" && parts[1] && ["files", "reports", "periods"].includes(parts[2]) && parts.length === 3)
    return { page: parts[2]!, scope: { projectID: parts[1], periodID: query.get("period") || undefined } as CollectionScope }
  if (!scopedCollections.has(parts[0] ?? "") || parts.length !== 1) return
  return { page: parts[0]!, scope: {
    companyID: query.get("company") || undefined,
    projectID: query.get("project") || undefined,
    periodID: query.get("period") || undefined,
  } as CollectionScope }
}

export function collectionPath(page: string, scope: CollectionScope = {}) {
  let path = `/${page}`
  const query = new URLSearchParams()
  if (page === "projects" && scope.projectID) path = `/projects/${encodeURIComponent(scope.projectID)}/overview`
  else if (["files", "reports", "periods"].includes(page) && scope.projectID) path = `/projects/${encodeURIComponent(scope.projectID)}/${page}`
  else if (["files", "reports", "projects"].includes(page) && scope.companyID)
    path = `/companies/${encodeURIComponent(scope.companyID)}/${page}`
  else {
    if (scope.companyID) query.set("company", scope.companyID)
    if (scope.projectID) query.set("project", scope.projectID)
  }
  if (scope.periodID && scope.projectID) query.set("period", scope.periodID)
  return `${path}${query.size ? `?${query}` : ""}`
}

export function useCollectionScope() {
  const location = useLocation()
  return createMemo(() => collectionRoute(location.pathname, location.search)?.scope ?? {})
}
